import { grey } from "@mui/material/colors";
import { CommitmentsGroupResponse } from "@/services/cloudchipr.api";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";

type CommitmentsHighChartsData = {
  costBased: HighchartsChartDataType;
  percentBased: HighchartsChartDataType;
};

export const generateHighChartsDataFromCommitments = (
  data?: CommitmentsGroupResponse[],
): CommitmentsHighChartsData => {
  const categories = data?.map((group) => group.name ?? "") ?? [];
  const costData = [
    {
      name: "Utilization",
      color: "#9966FF",
      data:
        data?.map((group) => ({ y: group?.utilization?.amount ?? 0 })) ?? [],
    },
    {
      name: "Waste",
      color: grey[400],
      data: data?.map((group) => ({ y: group?.waste?.amount ?? 0 })) ?? [],
    },
  ];

  const percentData = [
    {
      name: "Utilization",
      color: "#9966FF",
      data:
        data?.map((group) => ({ y: group?.utilization?.percentage ?? 0 })) ??
        [],
    },
    {
      name: "Waste",
      color: grey[400],
      data: data?.map((group) => ({ y: group?.waste?.percentage ?? 0 })) ?? [],
    },
  ];

  return {
    costBased: {
      categories,
      series: costData,
    },
    percentBased: {
      categories,
      series: percentData,
    },
  };
};
